// extracted by mini-css-extract-plugin
module.exports = {"body":"OrderMaker_body__7q3Yn","remainderContainer":"OrderMaker_remainderContainer__1XSbD","remainder":"OrderMaker_remainder__3gb_F","container":"OrderMaker_container__HtHRS"};